import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Evento} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';
import {DateTime} from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class ApiEventService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);
  /*** eventos ***/

  // getAgenda(id: number): Promise<Evento[]> {
  //   const url = `${this.apiUrl}eventos/${id}`;
  //   return firstValueFrom(this.http.get<Evento[]>(url))
  // }
  getEvento(id: number): Promise<Evento> {
    const url = `${this.apiUrl}eventos/actual/${id}`;
    return firstValueFrom(this.http.get<Evento>(url))
  }
  getHorariosAlumno(id: number, mes: number, year: number): Promise<Evento[]> {
    const url = `${this.apiUrl}eventos/mes/${id}/${mes}/${year}`;
    return firstValueFrom(this.http.get<Evento[]>(url))
  }
  // getUltimosHorariosAlumno(id: number): Promise<Evento[]> { // <- DEPRECATED 17/05/2026
  //   const url = `${this.apiUrl}eventos/ultimaasistencia/${id}`;
  //   return firstValueFrom(this.http.get<Evento[]>(url))
  // }
  getAsistenciaCentro(fecha: string): Promise<Evento[]> {
    const url = `${this.apiUrl}eventos/asistencia/${fecha}`;
    return firstValueFrom(this.http.get<Evento[]>(url))
  }
  setSiesta(datos: Evento): Promise<any> {
    const url = `${this.apiUrl}eventos/siesta/${datos.id}`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  setRutina(datos: {id: number, rutina: string, valor: string|number}): Promise<any> {
    const url = `${this.apiUrl}eventos/rutinas/${datos.id}`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  saveMasivo(datos: {listado: number[], rutina: string, estate: boolean}): Promise<any> {
    const url = `${this.apiUrl}eventos/masivo`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  salida(id: number, datos: object): Promise<any> {
    const url = `${this.apiUrl}eventos/salida/${id}`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  salidaTodos(ids: number[]): Promise<void> {
    const url = `${this.apiUrl}eventos/salida/todos`;
    return firstValueFrom(this.http.post<void>(url, {ids: ids}))
  }
  setEnfermedad(datos: Evento): Promise<any> {
    const url = `${this.apiUrl}eventos/enfermo/${datos.child}`;
    return firstValueFrom(this.http.post<any>(url, {causa: datos.causa}))
  }
  updateEvento(datos: Evento): Promise<any> {
    const url = `${this.apiUrl}eventos/${datos.child}`;
    return firstValueFrom(this.http.post<any>(url, {data: datos}))
  }
  saveNotaPrivada(idAlumno: number, nota: string): Promise<any> {
    const fecha: string = DateTime.now().toSQLDate();
    const url = `${this.apiUrl}eventos/notaprivada/${fecha}/${idAlumno}`;
    return firstValueFrom(this.http.post<any>(url, {nota}))
  }

}
